import React, { Component } from "react";
import "./index.scss";
import { OwnIcon } from "../../@component/icons/module-icons";

export class NavigationBar extends Component {
  static defaultProps = {};
  mainRef = React.createRef().current;
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  _timeout = null;
  onClick = (key) => (e) => {
    const docTarget = document.querySelector(`[fox-page="${key}"]`) || document.querySelector(`[fox-key="${key}"]`) || document.querySelector(`[fox-pages="${key}"]`);
    if (docTarget) {
      this.smoothScrollToElement(docTarget);
    }
  };

  smoothScrollToElement = (element) => {
    if (!element) return;
    const duration = 600;
    const start = window.document.body.scrollTop;
    const rect = element.getBoundingClientRect();
    const end = start + rect.top;
    const target = Math.min(start, end);
    const change = end - start;

    // const target = Math.min(start, end);
    // const change = start - target;
    const startTime = performance.now();
    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
      const currentScroll = start + change * ease;
      window.document.body.scrollTo(0, currentScroll);
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }
    requestAnimationFrame(animateScroll);
  };

  getMenu = Object.freeze([
    { icon: "home", id: "home" },
    { icon: "heart", id: "love" },
    { icon: "date", id: "date" },
    { icon: "wedding", id: "story" },
    { icon: "album", id: "gallery" },
    { icon: "comment", id: "comments" },
  ]);
  render() {
    return (
      <section className={"desktop-bar add-shad navigation_bar skip-check"} style={{ display: "block" }}>
        <div className="wrapper_bar ">
          <ul className="padding-bar">
            {this.getMenu.map((menu, i) => (
              <li key={i}>
                <button className="navbar_icon icon-date" id={menu.id} onClick={this.onClick(menu.id)}>
                  <OwnIcon type={menu.icon} />
                </button>
              </li>
            ))}
            {/* <li>
              <a className="navbar_icon icon-date active" id="home" onClick={() => this.onClick("home")}>
                <OwnIcon type="home" />
              </a>
            </li>
            <li>
              <a className="navbar_icon icon-date" id="love" onClick={() => this.onClick("love")}>
                <OwnIcon type="heart" />
              </a>
            </li>
            <li>
              <a className="navbar_icon icon-date" id="date" onClick={() => this.onClick("date")}>
                <OwnIcon type="date" />
              </a>
            </li>
            <li>
              <a className="navbar_icon icon-date" id="story" onClick={() => this.onClick("story")}>
                <OwnIcon type="wedding" />
              </a>
            </li>
            <li>
              <a className="navbar_icon icon-date" id="gallery" onClick={() => this.onClick("gallery")}>
                <OwnIcon type="album" />
              </a>
            </li>
            <li>
              <a className="navbar_icon icon-date" id="comments" onClick={() => this.onClick("comments")}>
                <OwnIcon type="comment" />
              </a>
            </li> */}
          </ul>
        </div>
      </section>
    );
  }
}
